import { Container } from './style/styled';

export const Search = () => {
  return <Container>STOCK COUNT search</Container>;
};
